import React from 'react'
import { Field, useFormState } from 'react-final-form'

const UpdateVersionField = () => {
  const { pristine } = useFormState({ subscription: { pristine: true } })

  return !pristine ? <Field component="input" className="hidden" name="update_version" defaultValue={true} /> : null
}
export default UpdateVersionField
